/**
 * LensDirect-style desktop cart (≥750px only). Mobile cart is untouched.
 */
(function () {
  var mq = window.matchMedia('(min-width: 750px)');

  function isDesktop() {
    return mq.matches && document.body.classList.contains('template-cart');
  }

  function getDesktopRoot() {
    return document.querySelector('.ciw-cart-desktop-layout');
  }

  function getSectionIds() {
    var ids = [];
    var itemsEl = document.getElementById('main-cart-items');
    var footerEl = document.getElementById('main-cart-footer');
    if (itemsEl && itemsEl.dataset.id) ids.push(itemsEl.dataset.id);
    if (footerEl && footerEl.dataset.id) ids.push(footerEl.dataset.id);
    return ids;
  }

  function parseSectionHtml(sectionHtml) {
    return new DOMParser().parseFromString(sectionHtml, 'text/html');
  }

  function delay(ms) {
    return new Promise(function (resolve) {
      window.setTimeout(resolve, ms);
    });
  }

  function getCartUpdateUrl() {
    return (window.routes && window.routes.cart_update_url) ? window.routes.cart_update_url : '/cart/update.js';
  }

  function postCartUpdate(payload) {
    var config = typeof fetchConfig === 'function'
      ? fetchConfig()
      : {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          }
        };

    return fetch(getCartUpdateUrl(), Object.assign({}, config, {
      credentials: 'same-origin',
      body: JSON.stringify(payload)
    })).then(function (response) {
      if (!response.ok) throw new Error('cart update failed');
      return response.json();
    });
  }

  function buildSectionRequest() {
    var sectionIds = getSectionIds();
    if (!sectionIds.length) return {};
    return {
      sections: sectionIds,
      sections_url: window.location.pathname
    };
  }

  function renderCartSections(sectionPayload) {
    if (!sectionPayload) return;

    var cartItemsEl = document.querySelector('cart-items');
    if (cartItemsEl && typeof cartItemsEl.applyCartSectionHtml === 'function') {
      cartItemsEl.applyCartSectionHtml(sectionPayload, null);
    } else if (cartItemsEl && typeof cartItemsEl.renderCartSections === 'function') {
      cartItemsEl.renderCartSections({ sections: sectionPayload });
    } else {
      var itemsEl = document.getElementById('main-cart-items');
      var footerEl = document.getElementById('main-cart-footer');
      var itemsSectionId = itemsEl && itemsEl.dataset.id;
      var footerSectionId = footerEl && footerEl.dataset.id;

      if (itemsSectionId && sectionPayload[itemsSectionId]) {
        var itemsDoc = parseSectionHtml(sectionPayload[itemsSectionId]);
        var newContents = itemsDoc.querySelector('#main-cart-items .js-contents');
        var oldContents = document.querySelector('#main-cart-items .js-contents');
        if (newContents && oldContents) oldContents.innerHTML = newContents.innerHTML;
      }

      if (footerSectionId && sectionPayload[footerSectionId]) {
        var footerDoc = parseSectionHtml(sectionPayload[footerSectionId]);
        var newFooter = footerDoc.getElementById('main-cart-footer');
        var oldBlocks = document.querySelector('#main-cart-footer .cart__blocks');
        var newBlocks = newFooter && newFooter.querySelector('.cart__blocks');
        if (oldBlocks && newBlocks) oldBlocks.innerHTML = newBlocks.innerHTML;
      }
    }

    bindDesktop();
    mountDesktopExpress();
    document.dispatchEvent(new CustomEvent('ciw:cart-dom-updated'));
  }

  function requestCartSections() {
    var cartItemsEl = document.querySelector('cart-items');
    if (cartItemsEl && typeof cartItemsEl.refreshCartSectionsFromServer === 'function') {
      return cartItemsEl.refreshCartSectionsFromServer().then(function () {
        bindDesktop();
        mountDesktopExpress();
      });
    }

    var sectionIds = getSectionIds();
    if (!sectionIds.length) return Promise.resolve();

    var cartUrl = (window.routes && window.routes.cart_url) ? window.routes.cart_url : '/cart';
    return fetch(
      cartUrl + '?sections=' + encodeURIComponent(sectionIds.join(',')) + '&sections_url=' + encodeURIComponent(window.location.pathname),
      { credentials: 'same-origin', headers: { Accept: 'application/json' } }
    )
      .then(function (response) {
        if (!response.ok) throw new Error('section fetch failed');
        return response.json();
      })
      .then(function (data) {
        renderCartSections(data.sections || data);
      });
  }

  function updateCart(payload) {
    return postCartUpdate(Object.assign({}, payload, buildSectionRequest())).then(function (data) {
      if (data && data.sections) {
        renderCartSections(data.sections);
        return data;
      }
      return requestCartSections().then(function () {
        return data;
      });
    });
  }

  function fetchCart() {
    var cartUrl = (window.routes && window.routes.cart_url) ? window.routes.cart_url : '/cart';
    return fetch(cartUrl + '.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('cart fetch failed');
      return response.json();
    });
  }

  function normalizePromoCode(code) {
    return String(code || '').trim().toUpperCase();
  }

  function cartHasFirst30Discount(cart) {
    if (!cart) return false;
    if ((cart.discount_codes || []).some(function (entry) {
      if (entry.applicable === false) return false;
      return normalizePromoCode(entry.code).indexOf('FIRST30') !== -1;
    })) return true;
    if ((cart.cart_level_discount_applications || []).some(function (discount) {
      return normalizePromoCode(discount.title).indexOf('FIRST30') !== -1;
    })) return true;
    return (cart.items || []).some(function (item) {
      return (item.line_level_discount_allocations || []).some(function (allocation) {
        var title = allocation.discount_application && allocation.discount_application.title;
        return normalizePromoCode(title).indexOf('FIRST30') !== -1;
      });
    });
  }

  function waitForFirst30Discount(attemptsLeft) {
    var remaining = typeof attemptsLeft === 'number' ? attemptsLeft : 5;
    return fetchCart().then(function (cart) {
      if (cartHasFirst30Discount(cart)) return cart;
      if (remaining <= 1) throw new Error('invalid discount');
      return delay(400).then(function () {
        return waitForFirst30Discount(remaining - 1);
      });
    });
  }

  function desktopPromoAppliedInSidebar() {
    return !!document.querySelector('.ciw-cart-desktop-sidebar [data-ciw-promo-applied]');
  }

  function cartHasDiscountCode(cart, code) {
    if (!cart) return false;
    var normalized = normalizePromoCode(code);
    if ((cart.discount_codes || []).some(function (entry) {
      if (entry.applicable === false) return false;
      return normalizePromoCode(entry.code) === normalized;
    })) return true;
    if ((cart.cart_level_discount_applications || []).some(function (discount) {
      return normalizePromoCode(discount.title) === normalized;
    })) return true;
    return (cart.items || []).some(function (item) {
      return (item.line_level_discount_allocations || []).some(function (allocation) {
        var title = allocation.discount_application && allocation.discount_application.title;
        return normalizePromoCode(title) === normalized;
      });
    });
  }

  function isLensReplacementCartOrder() {
    var cartItems = document.querySelector('cart-items');
    if (cartItems && cartItems.getAttribute('data-ciw-lr-order') === '1') return true;
    var summary = document.querySelector('[data-ciw-cart-summary][data-ciw-lr-order="true"]');
    return !!summary;
  }

  function cartHasRelens20Discount(cart) {
    return cartHasDiscountCode(cart, 'RELENS20');
  }

  function hitDiscountUrl(url) {
    var discountUrl = url;
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root && url.charAt(0) === '/') {
      discountUrl = window.Shopify.routes.root.replace(/\/?$/, '') + url;
    }
    return fetch(discountUrl, { method: 'GET', credentials: 'same-origin', redirect: 'follow' }).catch(function () {
      return null;
    });
  }

  function clearShopifyDiscount() {
    return hitDiscountUrl('/discount/').then(function () {
      return delay(400);
    });
  }

  function removeCartDiscount() {
    window.__ciwFirst30AutoApplyBlocked = true;
    return clearShopifyDiscount().then(function () {
      return updateCart({ attributes: { ciw_first30_dismissed: '1' } });
    }).then(function (cart) {
      window.ciwFirst30Dismissed = true;
      return cart;
    });
  }

  function applyFirst30() {
    if (isContactsCartOrder()) return Promise.reject(new Error('invalid discount'));
    window.__ciwFirst30AutoApplyBlocked = false;
    return fetchCart().then(function (cart) {
      if (cartHasFirst30Discount(cart)) {
        return updateCart({ attributes: { ciw_first30_dismissed: '' } }).then(function (updatedCart) {
          window.ciwFirst30Dismissed = false;
          return updatedCart;
        });
      }
      return hitDiscountUrl('/discount/FIRST30')
        .then(function () { return delay(400); })
        .then(function () { return waitForFirst30Discount(); })
        .then(function () {
          return updateCart({ attributes: { ciw_first30_dismissed: '' } });
        })
        .then(function (updatedCart) {
          window.ciwFirst30Dismissed = false;
          return updatedCart;
        });
    });
  }

  function applyOtherDiscount(code) {
    return hitDiscountUrl('/discount/' + encodeURIComponent(code))
      .then(function () { return delay(350); })
      .then(fetchCart)
      .then(function (cart) {
        if (!cartHasDiscountCode(cart, code)) throw new Error('invalid discount');
        return requestCartSections().then(function () { return cart; });
      });
  }

  function applyRelens20() {
    if (!isLensReplacementCartOrder()) return Promise.reject(new Error('invalid discount'));
    return fetchCart().then(function (cart) {
      if (cartHasRelens20Discount(cart)) {
        return requestCartSections().then(function () { return cart; });
      }
      return Promise.reject(new Error('relens20-auto'));
    });
  }

  function applyCartDiscount(code) {
    var normalized = normalizePromoCode(code);
    if (!normalized) return Promise.reject(new Error('empty'));
    if (normalized === 'CONTACTS20' && isContactsCartOrder()) return Promise.resolve();
    if (normalized === 'RELENS20' && isLensReplacementCartOrder()) return applyRelens20();
    if (normalized === 'FIRST30') return applyFirst30();
    return applyOtherDiscount(code);
  }

  function isContactsCartOrder() {
    var summary = document.querySelector('.ciw-cart-desktop-sidebar [data-ciw-cart-summary]');
    return summary && summary.getAttribute('data-ciw-contacts-order') === 'true';
  }

  function setPromoError(message) {
    var errorEl = document.querySelector('.ciw-cart-desktop-sidebar [data-ciw-promo-error]');
    if (!errorEl) return;
    if (message) {
      errorEl.textContent = message;
      errorEl.hidden = false;
    } else {
      errorEl.textContent = '';
      errorEl.hidden = true;
    }
  }

  function bindDesktopPromo() {
    if (!isDesktop()) return;
    var scope = document.querySelector('.ciw-cart-desktop-sidebar');
    if (!scope) return;

    var applyBtn = scope.querySelector('[data-ciw-promo-apply]');
    var removeBtn = scope.querySelector('[data-ciw-promo-remove]');
    var input = scope.querySelector('[data-ciw-promo-input]');

    if (applyBtn && !applyBtn.dataset.ciwDesktopPromoBound) {
      applyBtn.dataset.ciwDesktopPromoBound = 'true';
      applyBtn.addEventListener('click', function (event) {
        event.preventDefault();
        if (!input) return;
        var code = input.value.trim();
        if (!code) {
          setPromoError('Enter a promo code.');
          return;
        }
        if (normalizePromoCode(code) === 'CONTACTS20' && isContactsCartOrder()) {
          setPromoError('');
          input.value = '';
          return;
        }
        if (normalizePromoCode(code) === 'RELENS20' && isLensReplacementCartOrder()) {
          setPromoError('');
          applyBtn.disabled = true;
          applyRelens20()
            .then(function () {
              setPromoError('');
              if (input) input.value = '';
            })
            .catch(function () {
              setPromoError('RELENS20 applies automatically at checkout on lens replacement orders.');
            })
            .finally(function () {
              applyBtn.disabled = false;
            });
          return;
        }
        setPromoError('');
        applyBtn.disabled = true;
        applyCartDiscount(code)
          .then(function () {
            setPromoError('');
            if (input) input.value = '';
          })
          .catch(function () {
            if (normalizePromoCode(code) === 'FIRST30' && isContactsCartOrder()) {
              setPromoError('FIRST30 code is for glasses/sunglasses only. Restrictions apply.');
              return;
            }
            if (normalizePromoCode(code) === 'RELENS20' && isLensReplacementCartOrder()) {
              setPromoError('RELENS20 applies automatically at checkout on lens replacement orders.');
              return;
            }
            return requestCartSections().then(function () {
              if (normalizePromoCode(code) === 'FIRST30' && desktopPromoAppliedInSidebar()) {
                setPromoError('');
                if (input) input.value = '';
                return;
              }
              setPromoError('Invalid code. Please try again.');
            }).catch(function () {
              setPromoError('Invalid code. Please try again.');
            });
          })
          .finally(function () {
            applyBtn.disabled = false;
          });
      });
    }

    if (input && !input.dataset.ciwDesktopPromoBound) {
      input.dataset.ciwDesktopPromoBound = 'true';
      input.addEventListener('keydown', function (event) {
        if (event.key === 'Enter') {
          event.preventDefault();
          if (applyBtn) applyBtn.click();
        }
      });
    }

    if (removeBtn && !removeBtn.dataset.ciwDesktopPromoBound) {
      removeBtn.dataset.ciwDesktopPromoBound = 'true';
      removeBtn.addEventListener('click', function (event) {
        event.preventDefault();
        if (removeBtn.hasAttribute('data-ciw-promo-remove-locked')) {
          setPromoError('No, we refuse for you to pay more.');
          return;
        }
        removeBtn.disabled = true;
        setPromoError('');
        removeCartDiscount()
          .then(function () {
            if (input) input.value = '';
          })
          .catch(function () {
            return requestCartSections();
          })
          .finally(function () {
            removeBtn.disabled = false;
          });
      });
    }
  }

  function bindDesktopContactQty() {
    if (!isDesktop()) return;
    var root = getDesktopRoot();
    if (!root) return;

    root.querySelectorAll('[data-ciw-cl-qty-stepper]:not([data-ciw-desktop-qty-bound])').forEach(function (stepper) {
      stepper.setAttribute('data-ciw-desktop-qty-bound', 'true');
      var input = stepper.querySelector('.cl-eye-row__step-input');
      var display = stepper.querySelector('[data-ciw-cl-qty-display]');
      var minus = stepper.querySelector('[data-ciw-cl-qty-minus]');
      var plus = stepper.querySelector('[data-ciw-cl-qty-plus]');
      if (!input) return;

      var cartItems = input.closest('cart-items');
      if (!cartItems || typeof cartItems.updateQuantity !== 'function') return;

      var min = parseInt(input.getAttribute('data-min') || input.getAttribute('min'), 10);
      if (isNaN(min) || min < 1) min = 1;
      var max = parseInt(input.getAttribute('data-max') || input.getAttribute('max'), 10);
      if (isNaN(max)) max = null;

      function formatBoxLabel(qty) {
        var n = parseInt(qty, 10);
        if (isNaN(n) || n < min) n = min;
        return n + (n === 1 ? ' Box' : ' Boxes');
      }

      function syncStepper() {
        var value = parseInt(input.value, 10);
        if (isNaN(value)) value = min;
        if (display) display.textContent = formatBoxLabel(value);
        if (minus) minus.disabled = value <= min;
        if (plus) plus.disabled = max !== null && value >= max;
      }

      function setValue(nextValue) {
        var value = parseInt(nextValue, 10);
        if (isNaN(value)) value = min;
        if (value < min) value = min;
        if (max !== null && value > max) value = max;
        input.value = String(value);
        syncStepper();
        cartItems.updateQuantity(
          input.getAttribute('data-line-key') || input.dataset.index,
          value,
          '',
          input.dataset.quantityVariantId,
          input.dataset.index
        );
      }

      syncStepper();
      if (minus) minus.addEventListener('click', function () { setValue(parseInt(input.value, 10) - 1); });
      if (plus) plus.addEventListener('click', function () { setValue(parseInt(input.value, 10) + 1); });
    });
  }

  function bindDesktopRemove() {
    if (!isDesktop()) return;
    var root = getDesktopRoot();
    if (!root) return;

    root.querySelectorAll('.ciw-frame-cart__remove:not([data-ciw-desktop-remove-bound])').forEach(function (wrap) {
      wrap.setAttribute('data-ciw-desktop-remove-bound', 'true');
      var btn = wrap.querySelector('.ciw-frame-cart__remove-btn');
      if (!btn || btn.dataset.ciwDesktopRemoveBound) return;
      btn.dataset.ciwDesktopRemoveBound = 'true';
      btn.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        var cartItems = wrap.closest('cart-items');
        var lineKey = wrap.getAttribute('data-line-key');
        var line = wrap.getAttribute('data-index');
        if (!cartItems) return;
        if (lineKey && typeof cartItems.removeLineWithLinkedItems === 'function') {
          cartItems.removeLineWithLinkedItems(lineKey, line, '', '');
          return;
        }
        if (typeof cartItems.updateQuantity === 'function') {
          cartItems.updateQuantity(lineKey || line, 0, '', '', line);
        }
      });
    });
  }

  function bindDesktopDetails(root) {
    if (!isDesktop()) return;
    var scope = root || getDesktopRoot() || document;

    scope.querySelectorAll('.ciw-frame-cart__details:not([data-ciw-desktop-details-bound])').forEach(function (details) {
      details.setAttribute('data-ciw-desktop-details-bound', 'true');

      var summary = details.querySelector('summary');
      var body = details.querySelector('.ciw-ld-cart-details__body');
      if (!summary || !body) return;

      body.classList.add('ciw-cart-desktop-details__panel');
      details.setAttribute('open', '');

      var isOpen = false;
      var isAnimating = false;

      function measurePanelHeight() {
        body.style.height = 'auto';
        var measured = body.scrollHeight;
        body.style.height = isOpen ? 'auto' : '0';
        return measured;
      }

      function setClosed(instant) {
        isOpen = false;
        isAnimating = false;
        details.classList.remove('is-expanded');
        if (instant) {
          body.style.transition = 'none';
        }
        body.style.height = '0';
        if (instant) {
          body.offsetHeight;
          body.style.transition = '';
        }
      }

      function openPanel() {
        if (isOpen || isAnimating) return;
        isAnimating = true;
        details.classList.add('is-expanded');
        body.style.height = '0';
        body.offsetHeight;
        var targetHeight = measurePanelHeight();
        body.style.height = '0';
        body.offsetHeight;
        requestAnimationFrame(function () {
          body.style.height = targetHeight + 'px';
        });
        isOpen = true;
      }

      function closePanel() {
        if (!isOpen || isAnimating) return;
        isAnimating = true;
        isOpen = false;
        body.style.height = body.scrollHeight + 'px';
        body.offsetHeight;
        requestAnimationFrame(function () {
          body.style.height = '0';
        });
      }

      if (details.hasAttribute('data-ciw-details-default-open')) {
        openPanel();
      } else {
        setClosed(true);
      }

      body.addEventListener('transitionend', function (event) {
        if (event.propertyName !== 'height' || event.target !== body) return;
        isAnimating = false;
        if (isOpen) {
          body.style.height = 'auto';
          return;
        }
        details.classList.remove('is-expanded');
      });

      summary.addEventListener('click', function (event) {
        event.preventDefault();
        if (isOpen) {
          closePanel();
        } else {
          openPanel();
        }
      });
    });
  }

  function restoreDesktopExpressButtons() {
    if (!isDesktop()) return;

    var sidebarMount = document.querySelector('[data-ciw-express-sidebar-mount]');
    if (!sidebarMount) return;
    if (sidebarMount.querySelector('.cart__dynamic-checkout-buttons')) return;

    var mobileMount = document.querySelector('[data-ciw-express-mount]');
    var buttons = mobileMount && mobileMount.querySelector('.cart__dynamic-checkout-buttons');
    if (!buttons) return;
    if (sidebarMount.contains(buttons)) return;

    sidebarMount.appendChild(buttons);
    delete buttons.dataset.ciwExpressReady;
    delete buttons.dataset.ciwDesktopExpressReady;
  }

  function initDesktopExpress() {
    if (!isDesktop()) return;

    restoreDesktopExpressButtons();

    var sidebarMount = document.querySelector('[data-ciw-express-sidebar-mount]');
    if (!sidebarMount) return;

    var buttons = sidebarMount.querySelector('.cart__dynamic-checkout-buttons');
    if (!buttons) return;
    if (buttons.dataset.ciwDesktopExpressReady) return;

    buttons.dataset.ciwDesktopExpressReady = '1';
    if (window.Shopify && window.Shopify.PaymentButton) {
      window.Shopify.PaymentButton.init();
    }
  }

  function scheduleDesktopExpressMount() {
    window.clearTimeout(window.__ciwDesktopExpressMountTimer);
    window.__ciwDesktopExpressMountTimer = window.setTimeout(initDesktopExpress, 100);
  }

  function bindDesktop() {
    if (!isDesktop()) return;
    bindDesktopPromo();
    bindDesktopContactQty();
    bindDesktopRemove();
    bindDesktopDetails();
  }

  function init() {
    if (!document.body.classList.contains('template-cart')) return;
    bindDesktop();
    scheduleDesktopExpressMount();
    window.setTimeout(initDesktopExpress, 800);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    bindDesktop(event.target);
  });

  document.addEventListener('ciw:cart-dom-updated', function () {
    var sidebarMount = document.querySelector('[data-ciw-express-sidebar-mount]');
    var buttons = sidebarMount && sidebarMount.querySelector('.cart__dynamic-checkout-buttons');
    if (buttons) delete buttons.dataset.ciwDesktopExpressReady;
    bindDesktop();
    scheduleDesktopExpressMount();
    window.setTimeout(initDesktopExpress, 500);
  });

  if (typeof mq.addEventListener === 'function') {
    mq.addEventListener('change', function () {
      bindDesktop();
      scheduleDesktopExpressMount();
    });
  }
})();
